
<template>
    <div class="center">
      <vs-dialog prevent-close v-model="active" @close="borrarTodo">
        <template #header>
          <h4 class="not-margin">
            Crear registro
          </h4>
        </template>
        
        <div class="con-form">
            <vs-row>
                <vs-col sm="12" lg="4">
                    <form autocomplete="off">
                        <label for="institucion" class="labelInput">
                            Institución
                        </label>
                        <vs-select filter class="aqui pt-0" id="institucion" placeholder="Seleccionar Institución" :key="institucionId" v-model="institucion" v-if="instituciones.length" :disabled="!instituciones.length" autocomplete="off">
                            <template #message-danger v-if="errorFields.includes('institucion')">
                                Requerido
                            </template>
                            <template v-if="instituciones.length" autocomplete="off">
                                <vs-option v-for="option in instituciones" :key="option.id"  :label="option.text" :value="option.id">
                                    {{option.text}}
                                </vs-option>
                            </template>
                            <template v-else>
                                <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                                </vs-option>
                            </template>
                        </vs-select>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="4">
                    <form autocomplete="off">
                        <label for="periodicidad" class="labelInput">
                            Periodicidades 
                        </label>
                        <vs-select filter class="aqui pt-0" id="periodicidades " placeholder="Seleccionar Institución" :key="periodicidadId" v-model="periodicidad" v-if="periodicidades.length" :disabled="!periodicidades.length" autocomplete="off">
                            <template #message-danger v-if="errorFields.includes('periodicidad')">
                                Requerido
                            </template>
                            <template v-if="periodicidades.length" autocomplete="off">
                                <vs-option v-for="option in periodicidades" :key="option.id"  :label="option.titulo" :value="option.id">
                                    {{option.titulo}}
                                </vs-option>
                            </template>
                            <template v-else>
                                <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                                </vs-option>
                            </template>
                        </vs-select>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="4">
                    <form autocomplete="off">
                        <label for="nivel" class="labelInput">
                            Nivel Académico <i class="fas fa-shield-alt"></i>
                        </label>
                        <vs-select filter :loading="loadingNivel" class="aqui pt-0" id="nivel" placeholder="Seleccionar Nivel Académico" :key="nivelId" v-model="nivel" :disabled="!niveles.length">
                            <template #message-danger v-if="errorFields.includes('nivel')">
                                Requerido
                            </template>
                            <template v-if="niveles.length" autocomplete="off">
                                <vs-option v-for="option in niveles" :key="option.id"  :label="option.text" :value="option.id">
                                    {{option.text}}
                                </vs-option>
                            </template>
                            <template v-else>
                                <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                                </vs-option>
                            </template>
                        </vs-select>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="4">
                    <form autocomplete="off">
                        <label for="nombre" class="labelInput">
                            Nombre  <i class="fas fa-shield-alt"></i>
                        </label>
                        <vs-input class="pt-0" id="nombre" v-model="nombre" placeholder="Nombre" />
                    </form>
                </vs-col>
                <vs-col sm="12" lg="4">
                    <form autocomplete="off">
                        <label for="clave" class="labelInput">
                            Clave  <i class="fas fa-shield-alt"></i>
                        </label>
                        <vs-input class="pt-0" id="clave" v-model="clave" placeholder="Clave" />
                    </form>
                </vs-col>
                <vs-col sm="12" lg="4">
                    <form autocomplete="off">
                        <label for="rvoe" class="labelInput">
                            Rvoe  <i class="fas fa-shield-alt"></i>
                        </label>
                        <vs-input class="pt-0" id="rvoe" v-model="rvoe" placeholder="Rvoe" />
                    </form>
                </vs-col>
                <vs-col sm="12" lg="4">
                    <form autocomplete="off">
                        <label for="grados" class="labelInput">
                            No. grados  <i class="fas fa-shield-alt"></i>
                        </label>
                        <vs-input class="pt-0" id="grados" v-model="grados" placeholder="No. grados" />
                    </form>
                </vs-col>
                <vs-col sm="12" lg="4">
                    <form autocomplete="off">
                        <label for="reclutando" class="labelInput">
                            Actualmente reclutando  <i class="fas fa-shield-alt"></i>
                        </label>
                        <vs-select filter class="pt-0" placeholder="Actualmente reclutando" v-model="reclutando">
                            <vs-option label="Si" value="si">
                                Si
                            </vs-option>
                            <vs-option label="No" value="no">
                                No
                            </vs-option>
                        </vs-select>
                    </form>
                </vs-col>
            </vs-row>
        </div>
        <template #footer>
          <div class="footer-dialog">
              <vs-row>
                  <vs-col sm="6" lg="6">
                    <vs-button
                        danger
                        flat
                        @click="borrarTodo()">
                        Cancelar
                    </vs-button>
                  </vs-col>
                  <vs-col sm="6" lg="6">
                    <vs-button
                        success
                        class="ml-auto"
                        @click="postCrear()">
                        Guardar
                    </vs-button>
                  </vs-col>
              </vs-row>
          </div>
        </template>
      </vs-dialog>
    </div>
</template>
<script>
import academico from '../../../../../api/requests/academico'
export default {
    props:[
      'value',
      'info',
      'instituciones',
      'token'
    ],
    data:() => ({
        active: false,
        institucion: '',
        institucionId: (new Date()).getTime(),
        periodicidad: '',
        periodicidades: [
            {
                'id': 1,
                'periodicidad': 'Anual',
                'titulo': 'Grado (Año)'
            },
            {
                'id': 2,
                'periodicidad': 'Semestral',
                'titulo': 'Semestre'
            },
            {
                'id': 3,
                'periodicidad': 'Cuatrimestral',
                'titulo': 'Cuatrimestre'
            },
            {
                'id': 4,
                'periodicidad': 'Trimestral',
                'titulo': 'Trimestre' 
            },
            {
                'id': 5,
                'periodicidad': 'Bimestral',
                'titulo': 'Bimestre' 
            },
            {
                'id': 6,
                'periodicidad': 'Flexible',
                'titulo': 'Flexible' 
            }
        ],
        periodicidadId: (new Date()).getTime(),
        nivel: '',
        niveles: [],
        nivelId: (new Date()).getTime(),
        loadingNivel: false,
        nombre: '',
        clave: '',
        rvoe: '',
        grados: '',
        reclutando: '',
        errorFields: []
    }),
    methods: {
        getCancelar(){

        },
        async getNivelAcademico() {
            if(this.institucion){
                this.nivel = ''
                this.loadingNivel = true
                const params = {
                    "institucion_id": this.institucion
                }
                const { data: response } = await academico.getNivelAcademicoProgramas(params)
                this.niveles = response
                this.nivelId = (new Date()).getTime()
                this.loadingNivel = false
            }
        },
        sanityForm () {
            this.errorFields = []
            if (this.institucion == '') {
                this.errorFields.push('institucion')
            }
            if (this.nivel == '') {
                this.errorFields.push('nivel')
            }
            if (!this.errorFields.length){
                const formData = new FormData()
                formData.append('institucion_id', this.institucion)
                formData.append('periodicidad_id', this.periodicidad)
                formData.append('nivel_academico_id', this.nivel)
                formData.append('nombre', this.nombre)
                formData.append('clave_interna', this.clave)
                formData.append('revoe', this.rvoe)
                formData.append('no_grados', this.grados)
                formData.append('reclutando_nuevo_ingreso', this.reclutando)
                formData.append('_token', this.token)
                return formData
            } else {
                return null
            }
        },
        async postCrear(){
            const info = this.sanityForm()
            if(info){
                const loading = this.$vs.loading();
                try{
                    const { data: response } = await academico.postProgramasCrear(info)
                    loading.close()
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'success',
                        position: null,
                        title: 'Operación éxitosa.',
                        text: 'Se a creado con éxito el registro.'
                    })
                    console.log(this.institucion)
                    console.log(this.nivel)
                    this.$emit('refreshTable', this.institucion, this.nivel)
                    this.borrarTodo()
                }catch(error){
                    loading.close()
                    console.log(error)
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'danger',
                        position: null,
                        title: 'Hubo un error.',
                        text: 'Por favor de contactar al administrador.'
                    })
                }
            }
        },
        borrarTodo(){
            this.institucion = ''
            this.periodicidad = ''
            this.nivel = ''
            this.nombre = ''
            this.clave = ''
            this.revoe = ''
            this.grados = ''
            this.reclutando = ''
            this.active = false
        }
    },
    watch:{
      value (val) {
          this.active = val
      },
      async active (val) {
          if (!val){
              this.$emit('input', val);
          }
      },
      institucion(){
          this.getNivelAcademico()
      }
    }
}
</script>

<style lang="scss" scoped>
    .tache{
        position: absolute;
        cursor: pointer;
        top: 35px;
        @media only screen and (max-width: 768px) {
            left: calc(95% - 4em);
        }
        @media only screen and (min-width: 768px) {
            left: calc(98% - 4em);
        }

    }
</style>